module.exports = __webpack_public_path__ + "static/header-za-tehnologiju-60c4ab36209263f7ef31c5932b2a5e8e.png";